"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOnDocumentReadyPromise = void 0;
function getOnDocumentReadyPromise() {
    return new Promise(resolve => {
        if (document.readyState == 'complete') {
            return resolve();
        }
        window.addEventListener('load', () => resolve());
    });
}
exports.getOnDocumentReadyPromise = getOnDocumentReadyPromise;
